var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"noteQuestionPoll"},[_c('p',[_vm._v(_vm._s(_vm.labelsQuestionPoll[_vm.data[0]]))]),_c('starRatingMini',{attrs:{"percent":_vm.data[1] / 5 * 100}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }